import { useToggle } from "ahooks"
import { styled } from "styled-components"
import { FilterList } from "../Common/FilterList"
import { LabelItem } from "../Common/LabelItem"
import { useSearchConditionMobile } from "../hooks/useSearchCondition"
import React from "react"
import _ from "lodash"



const FilterClientTypeMobileView = styled.div`



`

export interface FilterClientTypeMobileProps {
  onChange?(value:any[]):void,
  value?: any[]
}




export const FilterClientTypeMobile = (props: FilterClientTypeMobileProps)=>{
  const { onChange,...reset } = props
  const { searchCondition,loading, visible, toggle } = useSearchConditionMobile({ client: ["type"] });
  let options = searchCondition.client?.type
  return <FilterClientTypeMobileView>
    <LabelItem
      label='客户类型'
      options={options}
      value={props.value}
      onClick={toggle}
    />
    {
      <FilterList
        {...reset}
        headerText='客户类型'
        visible={visible}
        loading={loading}
        onClose={toggle}
        onChange={props?.onChange}
        dataSource={options||[]}
      />
    }
  </FilterClientTypeMobileView>

}